module.exports = __webpack_public_path__ + "img/27000.efc97d16.jpg";